import { Environment as EnvironmentInterface } from '../app/core/interfaces/environment.interface';
import { Injectable } from '@angular/core';
import { EnvironmentService } from 'src/app/shared/services/environment.service';

@Injectable()
export class Environment implements EnvironmentInterface {
  production!: boolean;
  apiBaseUrl!: string;
  angularBaseUrl!: string;
  azureAD!: {
    auth: {
      uiClientId: string;
      authority: string;
    };
    resources: {
      msGraph: {
        resourceUri: string;
        resourceScope: string;
      };
      resourceScopeUri: string;
    };
    cache: {
      cacheLocation: string;
    };
    scopes: {
      loginRequest: string[];
    };
  };
  angularLogoutUrl: string;
  defaultauth: string;
  applicationName: string;
  firebaseConfig: {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };

  constructor(private environmentService: EnvironmentService) {}

  async init(): Promise<void> {
    if (!this.environmentService.isInitialized()) {
      await this.environmentService.initializeEnvironment();
    }
    const loadedEnvironment = this.environmentService.getEnvironment();
    Object.assign(this, loadedEnvironment); // Map loaded properties to the class
  }
}

const envService = new EnvironmentService();
// Create an instance of the Environment class
const environmentInstance = new Environment(envService);

// Initialize the environment asynchronously
(async () => {
  await environmentInstance.init();
})().catch((error) => {
  console.error('Failed to initialize environment:', error);
});

// Export the environment for backward compatibility
export const environment: EnvironmentInterface = environmentInstance;
